import { Empty } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { ANTD_GRAY } from '../../constants';
import { useEntityData } from '../../EntityContext';
import { sanitizeUrl } from '../../../../shared/utils/sanitizationUtils';

const EmbedContainer = styled.div`
    width: 100%;
    height: 100%;
`;

const StyledIframe = styled.iframe`
    width: 100%;
    height: 100%;
`;

const StyledEmpty = styled(Empty)`
    margin-top: 28px;
    font-size: 16px;
    color: ${ANTD_GRAY[8]};
`;

export const EmbedTab = () => {
    const { entityData } = useEntityData();
    const embedRenderUrl = entityData?.embed?.renderUrl;

    // Sanitize the URL to prevent XSS attacks through malicious iframe sources
    const sanitizedUrl = embedRenderUrl ? sanitizeUrl(embedRenderUrl) : null;

    return (
        <EmbedContainer>
            {(sanitizedUrl && <StyledIframe src={sanitizedUrl} title={entityData?.urn} frameBorder={0} />) || (
                <StyledEmpty description="No preview was found." />
            )}
        </EmbedContainer>
    );
};
